/* eslint-disable no-nested-ternary */
import { PayloadAction } from '@reduxjs/toolkit';
import { Property } from 'models/Properties';
import { StackedCalendarState } from '../types';

export default function updateVisiblePropertiesReducer(
  state: StackedCalendarState,
  {
    payload: { appendToExisting, properties },
  }: PayloadAction<{ properties: Property[]; appendToExisting?: boolean }>,
) {
  const expandedProperties = JSON.parse(
    localStorage.getItem('stackedCalendar_expandedProperties') || '{}',
  );

  const currentVisibleProperties = state.visibleProperties;

  state.visibleProperties = [
    ...(appendToExisting ? currentVisibleProperties : []),
    ...properties
      .map(({ uid, subUnits, unitTypes, businessType }) => {
        const isPropertyExpanded = expandedProperties[uid];

        return [
          `${uid}[${businessType}]`,
          ...(isPropertyExpanded && subUnits?.length > 0 ? subUnits : []).map(
            ({ uid: subUnitUid }) => `${subUnitUid}[SUB_UNIT]`,
          ),
          // @ts-expect-error TS2461 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
          ...(isPropertyExpanded === undefined
            ? unitTypes || []
            : // @ts-expect-error
            isPropertyExpanded && unitTypes?.length > 0
            ? unitTypes
            : []
          ).reduce(
            // @ts-expect-error TS2769 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
            (unitsAccumulator, { uid: unitTypeUid, units }) => {
              const isUnitTypeExpanded =
                expandedProperties[unitTypeUid] === true;
              const sortedUnits =
                units?.sort((a, b) => a.name.localeCompare(b.name)) || [];
              return [
                ...unitsAccumulator,
                `${unitTypeUid}[UNIT_TYPE]`,
                ...(isUnitTypeExpanded && sortedUnits?.length > 0
                  ? sortedUnits
                  : []
                ).map(({ uid: unitUid }) => `${unitUid}[UNIT]`),
              ];
            },
            [],
          ),
        ];
      })
      .reduce(
        (uidsAccumulator, propertyUids) => [
          ...uidsAccumulator,
          ...propertyUids,
        ],
        [],
      ),
  ];
}
